module.exports = __webpack_public_path__ + "static/media/04.b5340f55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/04.jpg
// module id = 265
// module chunks = 0